module.exports = __webpack_public_path__ + "static/media/boomie.973d6abc.jpg";